(function (window) {
  'use strict';

  var BLOCKED_KEYS = /^(email|first_name|last_name|name|answers?|customer(_id)?|order(_id)?|profile(_id)?|phone|address)$/i;
  var ALLOWED_CAMPAIGNS = ['colombia-el-tiple-warm-test-01'];

  function isQaMode() {
    try {
      return new URLSearchParams(window.location.search).get('hwc_qa') === '1';
    } catch (error) {
      return false;
    }
  }

  function campaignContext() {
    try {
      var value = new URLSearchParams(window.location.search).get('utm_campaign') || '';
      return ALLOWED_CAMPAIGNS.indexOf(value) !== -1 ? value : '';
    } catch (error) {
      return '';
    }
  }

  function sanitize(params) {
    var clean = {};
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (BLOCKED_KEYS.test(key)) return;
      if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return;
      clean[key] = typeof value === 'string' ? value.slice(0, 120) : value;
    });
    return clean;
  }

  function push(eventName, params) {
    if (!/^(blog_product_cta_click|blog_quiz_cta_click|lead_magnet_(view|submit)|coffee_quiz_(start|email_gate_view|email_submit|email_skip|complete|result_click))$/.test(eventName)) {
      return false;
    }

    var payload = sanitize(params);
    payload.event = eventName;

    if (isQaMode()) {
      window.__hwcQaEvents = window.__hwcQaEvents || [];
      window.__hwcQaEvents.push(payload);
      return true;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    return true;
  }

  window.HwcAcquisitionEvents = {
    push: push,
    sourcePath: function () { return window.location.pathname || '/'; },
    campaignContext: campaignContext,
    isQaMode: isQaMode
  };
})(window);
